<p>
  This locator tool allows users to search for organ transplant centers. Users may search by allowing the tool to detect
  their location automatically or by entering search criteria such as a ZIP Code, address, or place name.
</p>
